import { defaultHttpClient } from '../httpClient';
import type { GetCartMetaResponse } from './types';

/**
 * - 장바구니 메타 데이터를 조회하는 api
 */
export const getCartMeta = () => {
  return defaultHttpClient.request<GetCartMetaResponse>({
    method: 'GET',
    url: '/api/v2/carts/meta',
  });
};
